import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _CEImportDeclaration, _ImportRegistry, _single } from "../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../theme/Component/usePaginator";
import useModal, { MODAL_LG, MODAL_SM } from "../../theme/Component/hooks/useModal";
import { MASK_NUMBER } from "../../theme/Component/BasicMultiSelecTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { toast } from "react-toastify";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { GenericItem } from "../ImportRegistry/GenericItem";
import { NationalizationPhoto } from "../OptionComponents/NationalizationPhoto/NationalizationPhoto";
import { SignList } from "../OptionComponents/SignList/SignList";
import { ImportRegistry } from "../ImportRegistry/ImportRegistry";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { InputDate } from "../../theme/Input/InputDate";
import { SelectTHConstantsValue } from "../../bpm/config/Componentes/SelectTHConstantsValue";
import { InputMoney } from "../../theme/Input/InputMoney";
import { DownloadFileCard } from "../../theme/Component/DownloadFileCard";
import { BasicButton } from "../../theme/Component/BasicButton";

type filterProps = {
    Year: number;
    State: number;
    ContractNumber: string;
    CompanyName: string;
    ContractObject: string;
}

export const ImportDeclaration = () => {

    const importRegistry = useDataBean(_ImportRegistry);
    const { bean, setBean, lista, setLista, instance, handleChange, isMissing, isRequired, addRequiredFields, validateForm } = useDataBean(_CEImportDeclaration);
    const paginador = usePaginator();

    const [filter, setFilter] = useState<Partial<filterProps>>({
        Year: _single.getCurrenYear(),
        State: 1,
    })

    const [excelDocument, setExcelDocument] = useState<any>(null);
    const [excelError, setExcelError] = useState<string | null>(null);

    const modalItem = useModal("Items", MODAL_LG);
    const modalEdit = useModal("Editar", MODAL_LG);
    const modalDel = useModal("Eliminar Declaración de Importación", MODAL_SM);
    const modalImgs = useModal(`Registros fotograficos de ${bean.ContractNumber}`, MODAL_LG);
    const modalSigns = useModal(`Firmas de ${bean.ContractNumber}`, MODAL_LG);
    const modalExcel = useModal(`Reporte de ${bean.ContractNumber}`, MODAL_LG);

    const head = [
        { title: 'No', property: 'IDImportDeclaration', mask: MASK_NUMBER },
        { title: 'Contrato', property: 'ContractNumber' },
        { title: 'Objeto de Contrato', property: 'ContractObject', visible: false, Style: { minWidth: "350px" } },
        { title: 'Empresa', property: 'CompanyName' },
        { title: 'No Declaración', property: 'DeclarationNumber' },
        { title: 'Fecha Declaración', property: 'DeclarationDate' },
        { title: 'Tipo Declaración', property: 'TypeDeclarationName' },
        { title: 'Manifiesto de Carga', property: 'CargoManifest' },
        { title: 'Documento Transporte', property: 'TransportDocument' },
        { title: 'Depósito Aduanero', property: 'BondedWarehouse' },
        { title: 'Destino', property: 'DestinityName' },
        { title: 'Tasa de Cambio', property: 'ExchangeRate', mask: MASK_NUMBER },
        { title: 'Peso Bruto', property: 'GrossWeightDI', mask: MASK_NUMBER },
        { title: 'Observaciones', property: 'Observation' },
    ];

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { addItem() } }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modalEdit.open() } },
            { titulo: 'Items', icono: 'ri-list-unordered', visible: _single.canEdit(), evento: () => { modalItem.open() } },
            // { titulo: 'Registros Fotograficos', icono: 'ri-camera-line', visible: _single.canEdit(), evento: () => { modalImgs.open() } },
            { titulo: 'Descargar Reporte en Excel', icono: 'ri-file-excel-line', visible: _single.canEdit(), evento: () => { getExcel(); } },
            { titulo: 'Firmas', icono: 'ri-quill-pen-line', visible: _single.canEdit(), evento: () => { modalSigns.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalDel.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    useEffect(() => {
        addRequiredFields(["IDImportRegistry"])
    }, [])

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        importRegistry.instance.getFormRegistryRender(_ImportRegistry.IMPORTDECLARATION, paginador.page, 15, _single.cleanMap(filter))
            .then((resp: any) => {
                setLista(resp.List);
                paginador.setPages(resp.NumberOfPages);
            }).catch(err => { toast.error(err) })
    }

    const addItem = () => {
        setBean({
            State: 1,
        });
        modalEdit.open("Agregar Declaración de Importación");
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const getExcel = () => {
        setExcelDocument(null);
        setExcelError(null);

        importRegistry.instance.getFormatExcelByForm(bean.IDImportDeclaration, _single.getAccountID(), importRegistry.instance.IMPORTDECLARATION).then(
            (resp: any) => {
                const document = resp?.Document?.DataBeanProperties
                    ?? resp?.DataBeanProperties?.Document?.DataBeanProperties;

                if (!document?.URL) {
                    setExcelError(document?.ERR ?? "No se genero el archivo Correctamente");
                    modalExcel.open();
                    return;
                }

                setExcelDocument(document);
                modalExcel.open();
            }
        ).catch((err: any) => {
            setExcelError(err?.message ?? String(err ?? "Error desconocido al generar el archivo"));
            modalExcel.open();
        })
    }

    const editaItem = (obj: any) => {
        if (!validateForm()) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return;
        }
        instance.updateImportDeclaration({ ...obj, IDEmployee: _single.getAccountID() }).then(
            (resp: any) => {
                toast.success("Datos Guardados Correctamente");
                modalEdit.close();
                modalDel.close();
                getLista();
            }
        ).catch(err => { toast.error(err) })

    }

    return (
        <BasicPage titulo="Declaración de Importación">
            <div className="row ">
                <div className="col-md-4">
                    <label>Contrato</label>
                    <input type="text" className="form-control" value={filter.ContractNumber} onChange={(e) => { setFilter({ ...filter, ContractNumber: e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <label>Empresa</label>
                    <input type="text" className="form-control" value={filter.CompanyName} onChange={(e) => { setFilter({ ...filter, CompanyName: e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <label>Objeto del Contrato</label>
                    <input type="text" className="form-control" value={filter.ContractObject} onChange={(e) => { setFilter({ ...filter, ContractObject: e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" children={"Buscar"} useMargin />
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} records={paginador}></BasicTable>
                    {/* <PrintJson json={lista}/> */}
                    <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${isMissing('IDImportRegistry') ? 'has-error' : ''}`}>Contrato / Donación {isRequired('IDImportRegistry') ? <span className="text-danger">*</span> : ''}</label>
                                <ImportRegistry label=" " editor={true} idSelector={bean.IDImportRegistry} onChange={(e) => { setBean({ ...bean, IDImportRegistry: e.IDImportRegistry }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('DeclarationNumber') ? 'has-error' : ''}`}>No declaracion {isRequired('DeclarationNumber') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.DeclarationNumber} onChange={(e) => { setBean({ ...bean, DeclarationNumber: e.target.value }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('Autoahesivo') ? 'has-error' : ''}`}>Autoahesivo {isRequired('Autoahesivo') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.Autoahesivo} onChange={(e) => { setBean({ ...bean, Autoahesivo: e.target.value }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('IDTypeDeclarationPS') ? 'has-error' : ''}`}>Tipo de Declaración {isRequired('IDTypeDeclarationPS') ? <span className="text-danger">*</span> : ''}</label>
                                <SelectTHConstantsValue code={10002} value={bean.IDTypeDeclarationPS} onChange={(e: any) => { setBean({ ...bean, "IDTypeDeclarationPS": e }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('AceptDeclaration') ? 'has-error' : ''}`}>Aceptacion de Declaración {isRequired('AceptDeclaration') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.AceptDeclaration} onChange={(e) => { setBean({ ...bean, AceptDeclaration: e.target.value }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('DeclarationDate') ? 'has-error' : ''}`}>Fecha Declaración {isRequired('DeclarationDate') ? <span className="text-danger">*</span> : ''}</label>
                                <InputDate name="DeclarationDate" value={bean.DeclarationDate} setDate={(e) => { setBean({ ...bean, DeclarationDate: e }) }} label=" " />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('BondedWarehouse') ? 'has-error' : ''}`}>Deposito Aduanero {isRequired('BondedWarehouse') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.BondedWarehouse} onChange={(e) => { setBean({ ...bean, BondedWarehouse: e.target.value }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('CargoManifest') ? 'has-error' : ''}`}>Manifiesto de carga {isRequired('CargoManifest') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.CargoManifest} onChange={(e) => { setBean({ ...bean, CargoManifest: e.target.value }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('CargoManifestDate') ? 'has-error' : ''}`}>Fecha Manifiesto de Carga {isRequired('CargoManifestDate') ? <span className="text-danger">*</span> : ''}</label>
                                <InputDate name="CargoManifestDate" value={bean.CargoManifestDate} setDate={(e) => { setBean({ ...bean, CargoManifestDate: e }) }} label=" " />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('TransportDocument') ? 'has-error' : ''}`}>Documento de trasnsporte {isRequired('TransportDocument') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.TransportDocument} onChange={(e) => { setBean({ ...bean, TransportDocument: e.target.value }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('IDExporterPS') ? 'has-error' : ''}`}>Exportador  {isRequired('IDExporterPS') ? <span className="text-danger">*</span> : ''}</label>
                                <SelectTHConstantsValue code={10003} value={bean.IDExporterPS} onChange={(e: any) => { setBean({ ...bean, "IDExporterPS": e }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('IDTransportModePS') ? 'has-error' : ''}`}>Modo de trasporte {isRequired('IDTransportModePS') ? <span className="text-danger">*</span> : ''}</label>
                                <SelectTHConstantsValue code={10004} value={bean.IDTransportModePS} onChange={(e: any) => { setBean({ ...bean, "IDTransportModePS": e }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('ExchangeRate') ? 'has-error' : ''}`}>Tasa de cambio {isRequired('ExchangeRate') ? <span className="text-danger">*</span> : ''}</label>
                                <InputMoney _style="decimal" _value={bean.ExchangeRate} _label=" " onChange={(e) => { setBean({ ...bean, ExchangeRate: e }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('IDModalityPS') ? 'has-error' : ''}`}>Modalidad {isRequired('IDModalityPS') ? <span className="text-danger">*</span> : ''}</label>
                                <SelectTHConstantsValue code={10005} value={bean.IDModalityPS} onChange={(e: any) => { setBean({ ...bean, "IDModalityPS": e }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('IDImportTypePS') ? 'has-error' : ''}`}>Tipo de importación  {isRequired('IDImportTypePS') ? <span className="text-danger">*</span> : ''}</label>
                                <SelectTHConstantsValue code={10006} value={bean.IDImportTypePS} onChange={(e: any) => { setBean({ ...bean, "IDImportTypePS": e }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('IDPaymentTypePS') ? 'has-error' : ''}`}>Tipo de pago {isRequired('IDPaymentTypePS') ? <span className="text-danger">*</span> : ''}</label>
                                <SelectTHConstantsValue code={10007} value={bean.IDPaymentTypePS} onChange={(e: any) => { setBean({ ...bean, "IDPaymentTypePS": e }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('GrossWeightDI') ? 'has-error' : ''}`}>Peso {isRequired('GrossWeightDI') ? <span className="text-danger">*</span> : ''}</label>
                                <InputMoney _style="decimal" _value={bean.GrossWeightDI} _label=" " onChange={(e) => { setBean({ ...bean, GrossWeightDI: e }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('LicenceNumber') ? 'has-error' : ''}`}>Numero de licencia {isRequired('LicenceNumber') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.LicenceNumber} onChange={(e) => { setBean({ ...bean, LicenceNumber: e.target.value }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('IDDestinityPS') ? 'has-error' : ''}`}>Destino  {isRequired('IDDestinityPS') ? <span className="text-danger">*</span> : ''}</label>
                                <SelectTHConstantsValue code={10008} value={bean.IDDestinityPS} onChange={(e: any) => { setBean({ ...bean, "IDDestinityPS": e }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('ActaNumber') ? 'has-error' : ''}`}>Numero de acta {isRequired('ActaNumber') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.ActaNumber} onChange={(e) => { setBean({ ...bean, ActaNumber: e.target.value }) }} />
                            </div>

                            <div className="col-md-12">
                                <label className={`${isMissing('Observation') ? 'has-error' : ''}`}>Observaciones {isRequired('Observation') ? <span className="text-danger">*</span> : ''}</label>
                                <textarea className="form-control" value={bean.Observation} onChange={(e) => { setBean({ ...bean, Observation: e.target.value }) }} />
                            </div>

                        </div>
                    </Modal>

                    <ModalConfirm modal={modalDel.modal} updateModal={modalDel.setModal} eventModal={() => { deleteItem(); }}>
                        Eliminar delacaracion de importacion {bean.IDImportDeclaration} - {bean.ContractNumber}
                    </ModalConfirm>

                    <Modal modal={modalItem.modal} updateModal={modalItem.setModal}>
                        <GenericItem typeForm={_ImportRegistry.IMPORTDECLARATION} formBean={bean} />
                    </Modal>

                    <Modal modal={modalImgs.modal} updateModal={modalImgs.setModal} >
                        <NationalizationPhoto isModal idFormType={bean.IDImportDeclaration} formType={_ImportRegistry.IMPORTDECLARATION} />
                    </Modal>

                    <Modal modal={modalSigns.modal} updateModal={modalSigns.setModal} >
                        <SignList isModal idFormType={bean.IDImportDeclaration} formType={_ImportRegistry.IMPORTDECLARATION} />
                    </Modal>

                    <Modal modal={modalExcel.modal} updateModal={modalExcel.setModal}>
                        <DownloadFileCard
                            file={excelDocument}
                            error={excelError}
                            fallbackName="Reporte.xlsx"
                            fileTypeLabel="Archivo Excel"
                            buttonLabel="Descargar Excel"
                            icon="ri-file-excel-2-line"
                            iconClassName="text-success"
                            buttonClassName="btn-success"
                        />
                    </Modal>

                </div>
            </div>
        </BasicPage>
    )
}
